import {ClientMode, ViewerTool} from '../../enums';
import {ViewerToolDefinition} from '../../types';
import * as PropTypes from 'prop-types';

/**
 * Properties specifické pro mapový zobrazovač.
 */
export interface ViewerProps {
    /**
     * Nástroje dostupné jako plovoucí tlačítka nad mapou.
     */
    tools?: (ViewerTool | ViewerToolDefinition)[];

    /**
     * Nástroje dostupné skrze kontextové menu myši.
     */
    contextTools?: (ViewerTool | ViewerToolDefinition)[];

    /**
     * Příznak, zapínající režim nativního mobilního zobrazení.
     * Výchozí hodnota: `false`.
     */
    nativeMobile?: boolean;

    /**
     * Režim zobrazení, určující URL pro zobrazení v mapové komponentě.
     * Výchozí hodnota: {@link ClientMode.EMBED_EDITOR}
     */
    clientMode?: ClientMode;
}

/**
 * Typy properties specifických pro mapový zobrazovač.
 *
 * @ignore
 */
export const viewerPropTypes = {
    tools: PropTypes.array,
    contextTools: PropTypes.array,
    nativeMobile: PropTypes.bool,
    clientMode: PropTypes.oneOf(Object.values(ClientMode)),
};

/**
 * Výchozí hodnoty properties specifických pro mapový zobrazovač.
 *
 * @ignore
 */
export const viewerDefaultProps = {
    // Zcela záměrně neuvádíme default hodnoty properties, které se synchronizují s mapio.
    // 1) Jsou definovány na straně mapio. Neduplikujeme tím pádem logiku
    //    a neposíláme zbytečné zprávy přes frame.
    // 2) V rámci zpětné kompatibility udržujeme některé deprecated properties.
    //    Default ostatních properties by je mohl přepsat (pokud by šlo o alias).
    nativeMobile: false,
};
